import {useEffect, useState} from 'react';

import appConfig from '@/config/appConfig.typed';
import useLocationPathname from '@/hooks/useLocationPathname';
import {properties} from '@/services/analytics/ga/googleAnalytics';

const useGaPageTracking = () => {
    const googleTagManagerId = appConfig.getGoogleTagManagerId();
    const {isAem, pathname} = useLocationPathname();
    const [isPageTrackingSent, setIsPageTrackingSent] = useState(false);

    const pushToDataLayer = (event) => {
        // OneTrust can delay GTM injection; initialize the queue to avoid runtime crashes.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    };

    const trackInitialEvent = () => {
        pushToDataLayer({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });
    };

    useEffect(() => {
        if (!googleTagManagerId) return;
        if (!isPageTrackingSent) return;

        trackInitialEvent();
    }, [isPageTrackingSent]);

    useEffect(() => {
        if (!googleTagManagerId) return;
        if (isAem || !pathname) return;

        const event = {
            ...properties.pageId(),
            ...properties.market(),
            ...properties.userAgent(),
            ...properties.appVersion(),
            ...properties.userId(),
            ...properties.deviceType(),
            ...properties.source(),
        };

        pushToDataLayer(event);

        setIsPageTrackingSent(true);
    }, [isAem, pathname]);
};

export default useGaPageTracking;
